import { objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { CoreTooltip } from '../components/Tooltip/component.js';
function withTooltip(componentName) {
  return function (WrappedComponent) {
    var ComponentWithTooltip = function ComponentWithTooltip(props) {
      if (props.tooltip) {
        var _props$tooltip = props.tooltip,
          content = _props$tooltip.content,
          placement = _props$tooltip.placement;
        var computedProps = _objectSpread2({}, placement && {
          placement: placement
        });
        return /*#__PURE__*/React.createElement(CoreTooltip, _extends({
          hasArrow: true,
          label: content
        }, computedProps), /*#__PURE__*/React.createElement(WrappedComponent, props));
      }
      return /*#__PURE__*/React.createElement(WrappedComponent, props);
    };
    ComponentWithTooltip.displayName = "withTooltip(".concat(componentName, ")");
    return ComponentWithTooltip;
  };
}
export { withTooltip };